

import React, { useEffect } from "react";
import navLinks from "./navlinks.json";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Affiliation from "../assets/affiliationletter.pdf"
import Eco from "../assets/eco.pdf"
import time from "../assets/timetablle.pdf"
import IQAC from "../assets/IQAC.pdf"
import IDP from "../assets/IDP.pdf"

const Nav = (props) => {
  const { videos, hasVideoSection } = useSelector((state) => state.auth);
  const store = useSelector((state) => state.auth.store);
  const gallery_images = useSelector((state) => state.auth.gallery_images);
  const staffs = useSelector((state) => state.auth.staffs);

  const discloser = useSelector((state) => state.auth.discloser);

  const handleClick = () => {
    if (props.onTab) {
      props.onTab();
    }
  };
  useEffect(() => {
    const galleryHeads = [
      ...new Set(gallery_images.map((image) => image.title)),
    ];
    const staffStreams = [
      ...new Set(
        staffs
          .map((staff) => staff.stream)
          .filter((stream) => stream !== null && stream !== undefined)
      ),
    ];
    let a;

    navLinks[5] = {
      title: "Gallery",
      link: "/",
      subMenu: galleryHeads.map((e) => {

        return {
          title: e,
          link:
            "/gallery/" +
            e
              .toLowerCase()
              .replace(/ /g, "-")
              .replace(/[^\w-]+/g, "")
              .replace(/--+/g, "-")
              .replace(/^-+|-+$/g, ""),
        };
      }),
    };









    if (store.facilities) {
      navLinks[6] = {
        title: "Facilities",
        link: "/",
        subMenu: store.facilities.map((e) => {
          return {
            title: e.name,
            link:
              "/facilities/" +
              e.name
                .toLowerCase()
                .replace(/ /g, "-")
                .replace(/[^\w-]+/g, "")
                .replace(/--+/g, "-")
                .replace(/^-+|-+$/g, ""),
          };
        }),
      };
    }
  }, [store]);




  return (
    <ul
      id="mega-menu-primary"
      className="mega-menu max-mega-menu mega-menu-horizontal"
      data-event="hover_intent"
      data-effect="fade_up"
      data-effect-speed="200"
      data-effect-mobile="slide"
      data-effect-speed-mobile="200"
      data-mobile-force-width="false"
      data-second-click="go"
      data-document-click="collapse"
      data-vertical-behaviour="standard"
      data-breakpoint="768"
      data-unbind="true"
      data-mobile-state="collapse_all"
      data-hover-intent-timeout="300"
      data-hover-intent-interval="100"
    >
      {navLinks.map((link, index) => (
        <li
          key={index}
          className={`mega-menu-item mega-menu-item-type-custom  
          mega-menu-item-object-custom mega-menu-item-has-children mega-align-bottom-left mega-menu-flyout  mega-menu-item-${106 + index
            }`}
          id={`mega-menu-item-${106 + index}`}
        >
          <Link
            onClick={link.link == "#" ? "" : handleClick}
            className="mega-menu-link"
            aria-haspopup="true"
            aria-expanded="false"
            tabIndex="0"
            to={link.link}
          >
            {link.title}
          </Link>
          {link.subMenu && (
            <ul className="mega-sub-menu" style={{ maxHeight: '320px', overflowY: 'auto' }} >
              {link.subMenu.map((child, childIndex) => {

                if(
                  child.title === "IQAC Structure"
                ) {
                  return (
                    <li key={childIndex}
                  className="mega-menu-item mega-menu-item-type-custom"><a className="mega-menu-link" href={IQAC
                    } target="_blank">{child.title}</a></li>
                  )
                }

                     if(
                  child.title === "Affilliation"
                ) {
                  return (
                    <li key={childIndex}
                  className="mega-menu-item mega-menu-item-type-custom"><a className="mega-menu-link" href={Affiliation
                    } target="_blank">{child.title}</a></li>
                  )
                }


                     if(
                  child.title === "IDP"
                ) {
                  return (
                    <li key={childIndex}
                  className="mega-menu-item mega-menu-item-type-custom"><a className="mega-menu-link" href={IDP
                    } target="_blank">{child.title}</a></li>
                  )
                }


                if(
                  child.title === "Eco-Club"
                ) {
                  return (
                    <li key={childIndex}
                  className="mega-menu-item mega-menu-item-type-custom"><a className="mega-menu-link" href={Eco
                    } target="_blank">{child.title}</a></li>
                  )
                }

                  if(
                  child.title === "Timetable"
                ) {
                  return (
                    <li key={childIndex}
                  className="mega-menu-item mega-menu-item-type-custom"><a className="mega-menu-link" href={time
                    } target="_blank">{child.title}</a></li>
                  )
                }

                


       return (
             <li
                  key={childIndex}
                  className="mega-menu-item mega-menu-item-type-custom"
                >
                  <Link
                    onClick={handleClick}
                    className="mega-menu-link"
                    to={child.link}
                  >
                    {child.title}
                  </Link>
                </li>






)
              }
                
              )}
            </ul>
          )}
        </li>
      ))}
         <li className={`mega-menu-item mega-menu-item-type-custom  
          mega-menu-item-object-custom mega-menu-item-has-children mega-align-bottom-left mega-menu-flyout  mega-menu-item`}
      >

        <Link
          onClick={handleClick}
          className="mega-menu-link"
          aria-haspopup="true"
          aria-expanded="false"
          tabIndex="0"

        >
          Disclosure
        </Link>




        <ul className="mega-sub-menu" style={{ maxHeight: '320px', overflowY: 'auto' }}>


          {
            discloser.map((part) => (
              <li key={part.categoryId} className="mega-menu-item mega-menu-item-type-custom">

                
                <Link
                  to={`/data/${part.categoryId}/${part.categoryName.toLocaleLowerCase().split(" ").join("-")}`}
                    className="mega-menu-link"
                  rel="noopener noreferrer"
                  
                >
                {part.categoryName}
                </Link>
              </li>
            ))
          }




        </ul>


      </li>
    </ul>
  );
};

export default Nav;









































// [
//     {
//       "title": "Home",
//       "link": "/"
//     },




//     {
//       "title": "About",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "About Us",
//           "link": "/about/about-us/"
//         }

        
//       ]
//     },

//     {
//       "title": "Administration",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "Principal’s Message",
//           "link": "/administration/principals-message/"
//         }
 
//       ]
//     },


//     {
//       "title": "Faculties",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "Faculty of Science",
//           "link": "/faculties-staffs/science"
         
//         },
//         {
//           "title": "Faculty of Commerce",
//           "link": "/faculties-staffs/commerce"
//         }

//         ,
//         {
//           "title": "Non-Teaching Staff",
//           "link": "/faculties-staffs/commerce"
//         }

//       ]
//     },
    
//        {
//       "title": "Academic",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "Bachelor of Science",
//           "link": "/academic/courses/bsc"
//         },
//          {
//           "title": "Bachelor of Commerce",
//           "link": "/academic/courses/bcom"
//         }
//       ]
//     },


//     {
//       "title": "Gallery",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "Video Gallery",
//           "link": "/gallery/video/"
//         },
//         {
//           "title": "Photo Gallery",
//           "link": "/gallery/photo/"
//         },
//         {
//           "title": "In Newspaper",
//           "link": "/gallery/news/"
//         }
//       ]
//     },
    
//     {
//       "title": "Facilities",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "Video Gallery",
//           "link": "/gallery/video/"
//         },
//         {
//           "title": "Photo Gallery",
//           "link": "/gallery/photo/"
//         },
//         {
//           "title": "In Newspaper",
//           "link": "/gallery/news/"
//         }
//       ]
//     },


    
 


    
//     {
//       "title": "Students Corner",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "Admission Process",
//           "link": "/students/admission"
//         },
//         {
//           "title": "Prospectus",
//           "link": "/students/admission-rules"
//         },
        
//         {
//           "title": "Fee Structure",
//           "link": "/students/syllabus"
//         }
      
         
//       ]
//     },
//     {
//       "title": "Contact Forms",
//       "link": "#",
//       "subMenu": [
//         {
//           "title": "Contact US",
//           "link": "/contact-us/"
//         },
//         {
//           "title": "Feedback Form",
//           "link": "/feedback-form/"
//         }
       
//       ]
//     }
   
// ]
  









